module.exports = __webpack_public_path__ + "static/media/icontest.44263f13.jpg";